import { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';  // Correct import
import { useNavigate } from 'react-router-dom';

const useTokenExpiryHandler = (token) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;

    // Decode the token to get expiration time
    const decodedToken = jwtDecode(token);
    const expirationTime = decodedToken.exp * 1000; // Convert to milliseconds

    // Check if the token has already expired
    const isExpired = Date.now() >= expirationTime;
    if (isExpired) {
      logout();
    } else {
      // Set a timer to log out the user when the token expires
      const timeoutId = setTimeout(logout, expirationTime - Date.now());

      // Cleanup the timer on component unmount or if token changes
      return () => clearTimeout(timeoutId);
    }
  }, [token]);

  const logout = () => {
    // Clear tokens from local storage or any storage used
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    localStorage.removeItem('refresh_token');

    // Redirect to the login page
    navigate('/login');
  };
};

export default useTokenExpiryHandler;
